import {FC} from "react";
import {Card, Table} from "react-bootstrap";
import UploadSummaryRow from "./components/UploadSummaryRow.tsx";
import UseFileUploadSummary from "@oldDashboard/legacyHooks/useFileUploadSummary";
import Loader from "@/components/common/loader/loader";

interface LaunchTileProps {fileSummaryData: any, affiliateSelected:String, launchSelected: String, searching: boolean }
const FileUploadSummaryTile: FC<LaunchTileProps> = ({fileSummaryData,affiliateSelected, launchSelected, searching}) => {
    const { isLoading } = UseFileUploadSummary({launchSelected,affiliateSelected, searching});
    if(fileSummaryData.length == 0) return null;
    return (
        <Card className="custom-card overflow-hidden" style={{height: '250px'}}>
            {isLoading && <Loader />}
            <Card.Header className="justify-content-between">
                <Card.Title>
                    File Upload Summary
                </Card.Title>
            </Card.Header>
            <Card.Body className="p-0 overflow-hidden">
                <div className="table-responsive overflow-scroll" style={{height:"190px"}}>
                    <Table className="table text-nowrap">
                        <thead>
                            <tr>
                                <th className="position-sticky fixed-top" scope="row"></th>
                                <th className="position-sticky fixed-top" scope="row">Days</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                fileSummaryData.map(({label,  value } : {label:string, value: string}, index : number) => <UploadSummaryRow key={index} event={label} number_of_days={value} />)
                            }
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    );
};

export default FileUploadSummaryTile;